module.exports = __webpack_public_path__ + "img/wz-2-1.7432d7fa.png";